// Texty sekce hodnocení (reviews.js). Čísla a citace samy jsou DATA z manifestu
// shopu (SHOP.reviews) a z `/reviews/summary` + `/reviews/context`, sem patří
// jen popisky kolem nich. Znění nových textů recenze U2 schválil Tomáš 6. 10. 2026
// (mock na plátně).
export default {
  eyebrow: 'Ověřeno zákazníky',
  max: '/5',
  ctaLabel: 'Všechna hodnocení',
  countSuffix: 'hodnocení',
  customersLabel: 'zákazníků',
  /** skóre řádku platformy v hvězdách, „4,7 / 5" */
  platMax: '/ 5',
  /** jednotka řádku platformy v procentech, „96 %" */
  percent: '%',
  sourceMulti: 'Sečteno napříč platformami: ',
  sourceSingle: 'Hodnocení obchodu · ',
  /** věta pod souhrnem, když jsou v něm převedená procenta (names = platformy s procenty) */
  converted: (names, example) =>
    (names.length > 1
      ? names.slice(0, -1).join(', ') + ' a ' + names[names.length - 1] + ' uvádějí'
      : names[0] + ' uvádí') +
    ' procento spokojených zákazníků, do souhrnu ho převádíme na hvězdy (' + example + ').',
  /** příklad převodu ve větě výš: „96 % = 4,8" */
  convertedExample: (pct, stars) => pct + '\u00A0% = ' + stars,
  /** poznámka pod řádkem platformy, která přebírá hodnocení jiné (Firmy.cz ze Zboží.cz) */
  poolNote: (name) => 'sdílí hodnocení se ' + name,
  /** poznámka pod řádkem hodnocení z vlastního webu */
  ownNote: 'hodnocení přímo na našem webu',
  /** aria-label řádku platformy: „Heureka: 96 %, 6 930 hodnocení" */
  platformAria: (name, score, count) => name + ': ' + score + ', ' + count,
  /** skóre řádku pro čtečky: procenta a hvězdy */
  ariaPercent: (n) => n + '\u00A0%',
  ariaStars: (value) => value + ' z 5',
  /** nadpis řádku citací podle tématu stránky (search/indexer/reviews.mjs TOPICS) */
  quotesTitle: {
    obecne: 'Co o nás píšou zákazníci',
    doprava: 'Co zákazníci píšou o doručení',
    reklamace: 'Co zákazníci píšou o reklamacích a vrácení zboží',
    komunikace: 'Co zákazníci píšou o komunikaci s námi',
  },
  /** nadpis řádku, když jsou všechny citace recenze produktů kategorie */
  categoryTitle: (name) => 'Recenze produktů z kategorie ' + name,
  /** odkaz na sekci o ověřování recenzí na stránce hodnocení (§ 5a odst. 5 ZOS, reviewsVerify.js) */
  verify: 'Jak recenze ověřujeme',
  /** štítek citace z dotazníku Heureky */
  sourceHeureka: 'Ověřeno Heurekou',
  /** štítek citace napsané na webu („Recenze na Jipos.cz") */
  sourceWeb: (shop) => 'Recenze na ' + shop,
  /** aria-label hvězd citace */
  starsAria: (n) => n + ' z 5 hvězd',
};
